/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ProblemDetails,
  ProvinciaDTO,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ProvinciaDTOFromJSON,
    ProvinciaDTOToJSON,
} from '../models/index';

export interface GetProvinciaByIdRequest {
    codice: string;
}

/**
 * 
 */
export class ProvinceApi extends runtime.BaseAPI {

    /**
     */
    async getProvinceRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProvinciaDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Province`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProvinciaDTOFromJSON));
    }

    /**
     */
    async getProvince(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProvinciaDTO>> {
        const response = await this.getProvinceRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getProvinciaByIdRaw(requestParameters: GetProvinciaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProvinciaDTO>> {
        if (requestParameters['codice'] == null) {
            throw new runtime.RequiredError(
                'codice',
                'Required parameter "codice" was null or undefined when calling getProvinciaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/Province/{codice}`.replace(`{${"codice"}}`, encodeURIComponent(String(requestParameters['codice']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProvinciaDTOFromJSON(jsonValue));
    }

    /**
     */
    async getProvinciaById(requestParameters: GetProvinciaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProvinciaDTO> {
        const response = await this.getProvinciaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
